import logoIcon from "../../assets/images/logo-icon.svg";

const Loader = () => {
  return (
    <section className="loader">
      <div className="loader-inner">
        <img src={logoIcon} alt="logo" />
      </div>
    </section>
  );
};

export default Loader;
